import ReportGmailerrorredRoundedIcon from '@mui/icons-material/ReportGmailerrorredRounded';
import React from 'react';
import { styles } from './FlaggedTag.styles.js';
import { classNames } from '../../../../../utils/common/styling.js';

var FlaggedTag = function (_a) {
    var label = _a.label, className = _a.className;
    return (React.createElement("div", { className: classNames(styles.flaggedTag, className) },
        React.createElement(ReportGmailerrorredRoundedIcon, null),
        label));
};

export { FlaggedTag };
//# sourceMappingURL=FlaggedTag.js.map
